import { getSourceUrl } from "../envs/handleSourceUrl";

export const getExactQueryString = (paramKey) => {

  const sourceURL = getSourceUrl()

  const urlParams = new URL(sourceURL).searchParams

  return urlParams.get(paramKey)
}
